import request from "superagent";
import { last } from "lodash";
import { getTimesheetDistributionUrl } from "../utils/fileUpload";
import { showErrorToast } from "@src/appV2/lib/Notifications";

export const downloadDocument = async (baseUrl: string, name: string) => {
  let response;
  if (!baseUrl) {
    return;
  }
  try {
    const url = baseUrl.replace(/^http:\/\//i, "https://");
    response = await request.get(url).responseType("blob");

    const file = response.body;
    const src = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = src;
    const urlArray = file.type.toLowerCase().split("/");
    const extension = last(urlArray);
    // oxlint-disable-next-line typescript/restrict-template-expressions
    link.setAttribute("download", `${name}.${extension}`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    showErrorToast(`Unable to load requested file ${name}`);
    throw error;
  }
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'fileStorageFileKey' implicitly has an 'any' type.
export const downloadTimesheet = async (fileStorageFileKey, shiftId, name) => {
  if (!fileStorageFileKey || !shiftId) {
    return;
  }
  const distributionUrl = await getTimesheetDistributionUrl(fileStorageFileKey, shiftId);

  void downloadDocument(distributionUrl, name);
};
